<template>
    <div>

        <div v-if="loading">
            <i class="fa fa-circle-o-notch fa-spin"></i>
        </div>

        <div
                class="alert alert-warning"
                v-if="error"
        >
            <ul class="list-unstyled">
                <li v-for="e in error">
                    {{e[0]}}
                </li>
            </ul>
        </div>

        <div
                class="alert alert-danger"
                v-show="show"
        >
            <p>No data found.</p>
        </div>

        <div class="row">
            <div class="col-md-12">
                <div v-for="chart in charts">
                    <h4 class="mb-4">Periodicity: {{chart.periodicity.en}}</h4>
                    <single-chart
                            :periodicity="chart.periodicity"
                            :data="chart.data"
                            :headline="chart.headline"
                            :href="chart.href"
                            :link="chart.link"
                            :sources="chart.sources"
                    ></single-chart>
                </div>
            </div>
        </div>


    </div>
</template>

<script>

    export default {

        props: ['codeLists'],

        watch: {
            'storage.selected': 'updateData'
        },

        mounted: function () {
            this.updateData();
        },

        data: function () {
            return {
                storage: storage,
                charts: [],
                error: false,
                headline: '',
                loading: false,
            }
        },

        computed: {
            show: function () {
                return !this.loading && this.charts.length === 0 && !this.error
            },
        },

        methods: {
            updateData() {

                this.loading = true;
                this.error = false;
                this.charts = [];
                this.headline = '';

                let obj = {};
                this.codeLists.forEach(value => {

                    const id = value.id;
                    obj[id] = this.storage.selected.filter(code => {
                        return code.code_list === value.id
                    }).map(code => {
                        return code.id
                    });

                });

                window.http
                    .get(
                        '/api/v1/indicators/' + this.storage.database + '/data',
                        {params: obj}
                    )
                    .then(response => {
                        this.loading = false;
                        this.error = false;

                        this.charts = response.data.charts;

                        response.data.charts.forEach(chart => {
                            this.headline = chart.headline;
                        });

                    })
                    .catch((error) => {
                        this.error = error;
                        this.loading = false;
                    });
            }
        },

    }

</script>